// extracted by mini-css-extract-plugin
export default {"wrapper":"FlatSwiper_wrapper__FyMMo","pos":"FlatSwiper_pos__4H820"};